<template>
    <div class="srm-swatch srm-swatch-small" :style="{backgroundColor:color}"></div>
</template>
<script>
    import utils from "../utils/units";
    import * as common from "../utils/common";

    import { mapState, mapGetters } from 'vuex';

    export default {
        props: ['value'],
        computed: {
            ...mapState(["currentUser"]),
            ...mapGetters(["isMetric"]),
            color() {
                return utils.srmToHex(this.value);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/SrmLabel.vue